const segmentCustom = {
  getlist: 'segment/getlist',
  update: 'segment/update',
  getall: 'segment/getall',
  add: 'segment/add',
  get: 'segment/get',
  remove: 'segment/remove',
  getSampleUser: 'segment/execute',
  setArchive: 'segment/set-archive',
  ExportExcel: 'segment/export-excel',
}
export default segmentCustom
